<template>
  <v-container class="cmpbk black--text" id="home-container">
    <!--      
   13 Souls Run APP v0.8.1
    Copyright (c) 2024 Blue Cover Six LLC / John Molt
    BCS grants Unlimited License to 13 Souls LLC and Jeff Von Molt -->
    <h4 class="white--text">
      Thank you for your payment. Your transaction has been completed, and a
      receipt for your purchase may have been emailed to you. Log into your
      PayPal account or card provider to view transaction details.
    </h4>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
#home-container {
  max-width: 768px;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "completed",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
